import { useRecoilValue } from 'recoil';
import { getLiveStatus } from '../../../services/liveStatusService';
import { apiParamsState } from '../../../storage/app';

export function useLiveStatus() {
  const apiParams = useRecoilValue(apiParamsState);

  const getLiveStatusList = async () => {
    if (!apiParams) return;
    const { liveStatus, error } = await getLiveStatus(
      apiParams.clientId,
      apiParams.subClientId,
    );
    return {
      liveStatus,
      error,
    };
  }

  return {
    getLiveStatusList,
  };
}
